import { Navbar, Main, Product, Footer } from "../Components";

function Home() {
  return (
    <>
      <Navbar />
      <Main />
      <Product />
      <Footer />
    </>
  )
}

export default Home